<template>
  <div>
    <v-currency-field
      :label="label"
      type="tel"
      v-model.lazy="amount"
      v-bind="this.$store.state.currencyFormat"
      append-icon="fa-dollar"
      :rules="rules"
      maxlength="9"
      box
      hide-details
      :disabled="disabled"
      :error-messages="amount ? '' : 'Required'"
      :required="required"
      v-on:blur.stop.prevent="validateAmountThreshold('', $event)"
      ref="amountThreshold"
    ></v-currency-field>

    <v-dialog v-model="enabled" maxWidth="500px" persistent @keydown.esc.prevent="closeModal()" @input="v => v || closeModal()">
      <v-toolbar dense>
        <v-toolbar-title>Please Confirm</v-toolbar-title>
      </v-toolbar>

      <v-card>
        <v-card-text class="text-xs-center" fill-height>
          <v-layout row wrap align-center>
            <v-flex xs12>
              <h4>
                Are you sure you would like to enter an amount above ${{ Number(threshold).toFixed(2) }}?
              </h4>
            </v-flex>
            <v-flex xs6 pb-1 pt-3>
              <div class="text-xs-center">
                <v-btn color="primary" @click="closeModal(true)">Confirm</v-btn>
              </div>
            </v-flex>
            <v-flex xs6 pb-1 pt-3>
              <div class="text-xs-center">
                <v-btn color="error" @click="closeModal()">Stop</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AuthMixin from '@/mixins/auth'

export default {
  mixins: [AuthMixin],

  data: function () {
    return {
      bypass: false,
      enabled: false,
      threshold: 10000,

      rules: [
        (v) => !!v || 'Amount is required',
        (v) => !isNaN(v.replace(/[^0-9.-]+/g, '')) || 'Amount must be numeric',
        (v) => parseFloat(v.replace(/[^0-9.-]+/g, '')) >= 0 || 'Amount must be a positive amount',
        (v) => parseFloat(v.replace(/[^0-9.-]+/g, '')) > 0 || 'Amount must be greater than zero',
        // (v) => (!this.amountThresholdAllow && Number(v.replace(/[^0-9.-]+/g, '')) < this.amountThreshold) || `Verify amount over $${this.amountThreshold}.00`,
        (v) => (this.hasPermission('can_bypass_transaction_limit') || parseFloat(v.replace(/[^0-9.-]+/g, '')) <= 500000) || 'Amount must be $500,000 or less'
      ]
    }
  },

  props: {
    disabled: Boolean,
    label: {
      default: 'Amount',
      type: String
    },
    required: {
      default: true,
      type: Boolean
    },
    value: Number
  },

  watch: {
    '$route' (to, from) {
      this.reset()
    }
  },

  computed: {
    amount: {
      get () {
        return this.value
      },
      set (amount) {
        this.$emit('input', amount)
      }
    }
  },

  methods: {
    reset () {
      this.bypass = false
      this.enabled = false
    },

    closeModal (confirm = false) {
      this.bypass = confirm
      this.$refs.amountThreshold.$refs.textfield.focus()
      this.enabled = false
    },

    validateAmountThreshold (field, event) {
      if (this.amount >= this.threshold) {
        if (!this.bypass) {
          event.preventDefault()
          this.enabled = true
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/terminal/AmountThreshold.vue